
import FilePicker from 'components/Common/FilePicker'
import CustomEditor from 'components/TipTapEditor/CustomeEditor'
import { Form, Formik, useFormikContext } from 'formik'
import React from 'react'
import { Col, Row } from 'react-bootstrap'

function Step4({ setFieldValue, values }) {
    const { errors, submitCount } = useFormikContext();  
    
    return (
        <div>
            <div style={{ marginTop: "44px" }}>
                <h5 className="section-title">1.   SIGNATURE DETAILS</h5>
                <Row>
                    <Col xs='12' md='4'>
                        <p style={{ fontStyle: "italic", fontSize: "14px", color: "rgb(7, 30, 62);" }}>Your signature will appear at the end of all reports. It should include details like: your full name, accreditation, title, and contact (email).*</p>
                    </Col>
                    <Col xs='12' md='8'>
                        <div className="mb-4">
                            <div className="ck-editor-wrapper">
                                <CustomEditor name={`email_signature`} value={values?.email_signature} />
                            </div>
                        </div>
                    </Col>
                    <div>
                        <Row>
                            <Col xs='12' md='4' className='d-flex flex-column align-items-start justify-content-end'>
                                <p style={{ margin: 0, fontSize: "14px", color: "rgb(7, 30, 62);" }}>Signature Image File*</p>
                                <span style={{ fontSize: "12px", color: "#071E3E", fontWeight: 400 }}>Maximum size: 2MB</span>
                            </Col>
                            <Col xs='10' md='6'>
                                <span style={{ fontSize: "12px", color: "#071E3E", fontWeight: 600 }}>Upload a JPG or PNG</span>
                                <div>
                                    <div className="d-flex align-items-end gap-2">
                                        <FilePicker
                                            wrapper={{ width: "100%" }}
                                            value={values?.signature_img}
                                            onChange={(fileUrl) => {
                                                setFieldValue("signature_img", fileUrl)
                                            }}
                                        />
                                    </div>
                                </div>
                            </Col>

                        </Row>
                        {errors?.signature_img && (
                            <div className="text-danger text-center small mt-1">{errors?.signature_img}</div>
                        )}
                    </div>

                </Row>
            </div>
            <div style={{ marginTop: "44px" }}>
                <h5 className="section-title">2.   PROFILE IMAGE</h5>
                <Row>
                    <Col xs='12' md='4' className='d-flex flex-column align-items-start justify-content-end'>
                        <p style={{ margin: 0, fontSize: "14px", color: "rgb(7, 30, 62);" }}>Profile Image File</p>
                        <span style={{ fontSize: "12px", color: "#071E3E", fontWeight: 400 }}>Maximum size: 2MB</span>
                    </Col>
                    <Col xs='10' md='6'>
                        <span style={{ fontSize: "12px", color: "#071E3E", fontWeight: 600 }}>Upload a JPG or PNG</span>
                        <div className="d-flex align-items-end gap-2">
                            <FilePicker
                                wrapper={{ width: "100%" }}
                                value={values?.profile_picture}
                                onChange={(fileUrl) => {
                                    setFieldValue("profile_picture", fileUrl)
                                }}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Step4
